<template>
  <div class="tokyo_tm_portfolio">
    <div class="tokyo_tm_title">
      <div class="title_flex">
        <div class="left">
          <span>Gallery</span>
          <h3>See Our Gallery</h3>
        </div>
      </div>
    </div>

    <div v-if="activetab === 1" class="portfolio_list">
      <CoolLightBox :items="galleryItems" :index="index" @close="index = null">
      </CoolLightBox>
      <ul>
        <li
          v-for="(image, imageIndex) in galleryItems"
          :key="imageIndex"
          @click="index = imageIndex"
        >
          <div class="inner">
            <div class="entry tokyo_tm_portfolio_animation_wrap">
              <LazyImage 
                :src="image.thumb" 
                alt="Portfolio"
              />
            </div>
          </div>
        </li>
      </ul>
    </div>
  </div>
</template>

<script>
import LazyImage from './LazyImage.vue';

export default {
  components: {
    LazyImage
  },
  data() {
    return {
      activetab: 1,
      galleryItems: [
          {
            src: require("../assets/img/portfolio/1.jpg"),
            thumb: require("../assets/img/portfolio/1.jpg"),
          },
          {
            src: require("../assets/img/portfolio/2.jpg"),
            thumb: require("../assets/img/portfolio/2.jpg"),
          },
          {
  src: require("../assets/img/portfolio/3.jpg"),
  thumb: require("../assets/img/portfolio/3.jpg"),
},
{
  src: require("../assets/img/portfolio/4.jpg"),
  thumb: require("../assets/img/portfolio/4.jpg"),
},
{
  src: require("../assets/img/portfolio/5.jpg"),
  thumb: require("../assets/img/portfolio/5.jpg"),
},
{
  src: require("../assets/img/portfolio/6.jpg"),
  thumb: require("../assets/img/portfolio/6.jpg"),
},
{
  src: require("../assets/img/portfolio/7.jpg"),
  thumb: require("../assets/img/portfolio/7.jpg"),
},
{
  src: require("../assets/img/portfolio/8.jpg"),
  thumb: require("../assets/img/portfolio/8.jpg"),
},
{
  src: require("../assets/img/portfolio/9.jpg"),
  thumb: require("../assets/img/portfolio/9.jpg"),
},
{
  src: require("../assets/img/portfolio/10.jpg"),
  thumb: require("../assets/img/portfolio/10.jpg"),
},
{
  src: require("../assets/img/portfolio/11.jpg"),
  thumb: require("../assets/img/portfolio/11.jpg"),
},
{
  src: require("../assets/img/portfolio/12.jpg"),
  thumb: require("../assets/img/portfolio/12.jpg"),
},
{
  src: require("../assets/img/portfolio/13.jpg"),
  thumb: require("../assets/img/portfolio/13.jpg"),
},
{
  src: require("../assets/img/portfolio/14.jpg"),
  thumb: require("../assets/img/portfolio/14.jpg"),
},
{
  src: require("../assets/img/portfolio/15.jpg"),
  thumb: require("../assets/img/portfolio/15.jpg"),
},
{
  src: require("../assets/img/portfolio/16.jpg"),
  thumb: require("../assets/img/portfolio/16.jpg"),
},
{
  src: require("../assets/img/portfolio/17.jpg"),
  thumb: require("../assets/img/portfolio/17.jpg"),
},
{
  src: require("../assets/img/portfolio/18.jpg"),
  thumb: require("../assets/img/portfolio/18.jpg"),
},
{
  src: require("../assets/img/portfolio/19.jpg"),
  thumb: require("../assets/img/portfolio/19.jpg"),
},
{
  src: require("../assets/img/portfolio/20.jpg"),
  thumb: require("../assets/img/portfolio/20.jpg"),
},
{
  src: require("../assets/img/portfolio/21.jpg"),
  thumb: require("../assets/img/portfolio/21.jpg"),
},
{
  src: require("../assets/img/portfolio/22.jpg"),
  thumb: require("../assets/img/portfolio/22.jpg"),
},
{
  src: require("../assets/img/portfolio/23.jpg"),
  thumb: require("../assets/img/portfolio/23.jpg"),
},
{
  src: require("../assets/img/portfolio/24.jpg"),
  thumb: require("../assets/img/portfolio/24.jpg"),
},{
  src: require("../assets/img/portfolio/25.jpg"),
  thumb: require("../assets/img/portfolio/25.jpg"),
},
{
  src: require("../assets/img/portfolio/26.jpg"),
  thumb: require("../assets/img/portfolio/26.jpg"),
}
      ],
      index: null
    };
  }
};
</script>

<style lang="scss" scoped>
.portfolio_list ul li {
  list-style: none;
}
</style>
